import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const StickyNavigation = ({ children, className }) => {
  return (
    <div className={classnames('StickyFooter', className)}>
      { children }
    </div>
  );
};

StickyNavigation.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element
};

export default StickyNavigation;
